import {
  useRef,
  useEffect,
  useCallback,
} from 'react';
import type {
  RefObject,
} from 'react';

const useClickOutside = (
  ref: RefObject<HTMLElement>,
  callback: (() => void) | null,
) => {
  const callbackRef = useRef(callback);

  callbackRef.current = callback;

  const handleClick = useCallback((e: MouseEvent) => {
    if (
      !callback
    ) return;

    const target = e.target as HTMLElement;

    if (
      !target ||
      !ref.current ||
      ref.current.contains(target) ||
      target.closest('[data-component="Alert"]')
    ) return;

    callback();
  }, [callback]);

  useEffect(() => {
    const animationFrameId = requestAnimationFrame(() => {
      document.addEventListener('click', handleClick);
    });

    return () => {
      cancelAnimationFrame(animationFrameId);
      document.removeEventListener('click', handleClick);
    };
  }, [handleClick]);
};

export default useClickOutside;
